import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import "./LiteralGradeSelect.scss";

const gradeOptions = [
  { key: "", value: "", text: "-", className: "grade-empty" },
  { key: "AD", value: "AD", text: "AD", className: "grade-ad" },
  { key: "A", value: "A", text: "A", className: "grade-a" },
  { key: "B", value: "B", text: "B", className: "grade-b" },
  { key: "C", value: "C", text: "C", className: "grade-c" },
];

export function LiteralGradeSelect({ value, onChange, disabled, compact }) {
  const [open, setOpen] = useState(false);
  const [menuStyle, setMenuStyle] = useState({});
  const triggerRef = useRef(null);
  const menuRef = useRef(null);

  const getGradeClass = (val) => {
    switch (val) {
      case "AD": return "grade-selected-ad";
      case "A":  return "grade-selected-a";
      case "B":  return "grade-selected-b";
      case "C":  return "grade-selected-c";
      default:   return "";
    }
  };

  const currentOption =
    gradeOptions.find((o) => o.value === (value || "")) || gradeOptions[0];

  const handleToggle = () => {
    if (disabled) return;
    if (!open && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const menuHeight = gradeOptions.length * 38;
      const spaceBelow = window.innerHeight - rect.bottom;
      const openUpward = spaceBelow < menuHeight && rect.top > menuHeight;

      setMenuStyle({
        position: "fixed",
        left: rect.left,
        minWidth: rect.width,
        zIndex: 9999,
        ...(openUpward
          ? { bottom: window.innerHeight - rect.top }
          : { top: rect.bottom }),
      });
    }
    setOpen((prev) => !prev);
  };

  const handleSelect = (val) => {
    onChange(val);
    setOpen(false);
  };

  useEffect(() => {
    if (!open) return;

    const handleOutsideClick = (e) => {
      if (
        triggerRef.current &&
        !triggerRef.current.contains(e.target) &&
        menuRef.current &&
        !menuRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    const handleScroll = () => setOpen(false);

    document.addEventListener("mousedown", handleOutsideClick);
    window.addEventListener("scroll", handleScroll, true);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [open]);

  return (
    <>
      <div
        ref={triggerRef}
        role="listbox"
        aria-expanded={open}
        aria-disabled={disabled}
        className={`literal-grade-select ${getGradeClass(value)} ${compact ? "compact" : ""} ${open ? "active" : ""} ${disabled ? "disabled" : ""}`}
        onClick={handleToggle}
      >
        <span className="text">{currentOption.text}</span>
        <i className="dropdown icon" />
      </div>

      {open &&
        ReactDOM.createPortal(
          <div ref={menuRef} className="literal-grade-menu" style={menuStyle}>
            {gradeOptions.map((option) => (
              <div
                key={option.key}
                role="option"
                className={`literal-grade-menu__item ${option.className}`}
                onMouseDown={(e) => {
                  e.preventDefault();
                  handleSelect(option.value);
                }}
              >
                {option.text}
              </div>
            ))}
          </div>,
          document.body
        )}
    </>
  );
}
